import { t, uniq } from "utils";
import { alertSuccess, alertError } from "./index";
import { fetchReportedArticlesCount } from "../../actions/reportedArticles";


/* eslint-disable no-console */
export const sendNotice = (state, payload) => {
  let noticeInProgress = state.noticeInProgress.splice(0);

  // Manejar payload como objeto { articlesIds, source } o como array (backward compatibility)
  const articlesIds = payload && Array.isArray(payload) 
    ? payload 
    : (payload && payload.articlesIds 
      ? payload.articlesIds 
      : state.reportedArticles.map(article => article.id));
  
  const source = payload && !Array.isArray(payload) ? payload.source : null;

  noticeInProgress.push(...articlesIds);
  noticeInProgress = uniq(noticeInProgress);

  return {
    ...state,
    noticeInProgress,
    noticeSource: source != null ? source : null, // Solo guardar source si se pasa explícitamente
  };
};

export const sendNoticeSuccess = (state, payload) => {
  let sendingNotice = state.sendingNotice;
  let noticeInProgress = state.noticeInProgress;

  payload.sendNotice.articlesIds.forEach(articleId => {
    const articleIdFixed = articleId.split("-");
    sendingNotice.push(articleIdFixed[0]);
    noticeInProgress = noticeInProgress.filter((notice) => notice != articleId);
  });

  // Si viene de multiple_denounce_send y ya no quedan IDs pendientes, mostrar mensaje
  let sentNotices = false;
  if (state.noticeSource === "multiple_denounce_send" && noticeInProgress.length === 0) {
    alertSuccess(t('submit_multiple_denounce_send_ready'));
    sentNotices = true;
  }

  return {
    ...state,
    sendingNotice,
    noticeInProgress,
    sentNotices,
    noticeSource: sentNotices ? null : state.noticeSource,
  };
};

export const sendNoticeError = (state, payload) => {
  const { error, articlesIds } = payload;
  const noticeInProgress = state.noticeInProgress.splice(0);

  console.error(error.message);

  if (
    error.message.indexOf('article that was already denounced') !== -1
  ) {
    alertError(t('reported_articles.index.error_send_complaint_already'));
  } else {
    articlesIds && articlesIds.length === 1 ?
      alertError(t('reported_articles.index.error_send_complaint')) :
      alertError(t('reported_articles.index.error_send_all_complaints'));
  }

  articlesIds && articlesIds.forEach(articleId => {
    const indexOfArticle = noticeInProgress.indexOf(articleId);
    indexOfArticle > -1 && noticeInProgress.splice(indexOfArticle, 1);
  });

  return {
    ...state,
    noticeInProgress,
  };
};

export const removeArticleOptimistic = (state, payload) => {
  let reportedArticles = state.reportedArticles.slice(0);

  reportedArticles = reportedArticles.map(article => {
    if (article.id === payload.articleId) { article.removing = true; }
    return article;
  });

  return {
    ...state,
    isLoading: true,
    reportedArticles,
  };
};

export const removeArticleSuccess = (state, payload) => {
  let reportedArticles = state.reportedArticles
    .slice(0)
    .filter(article => article.id !== payload.deletedId);
  console.log("payload.deletedId" + payload.deletedId)
  console.log(reportedArticles)
  if (payload.article) {
    reportedArticles.push(payload.article);
  }

  alertSuccess(t('remove_article_success'));

  return {
    ...state,
    isLoading: false,
    reportedArticles,
    count: state.count - 1,
    countDB: state.count - 1,
    reportedArticlesFrom: payload.from,
  };
};

export const removeArticleError = (state, payload) => {
  let reportedArticles = state.reportedArticles.slice(0);
  reportedArticles = reportedArticles.map(article => {
    if (article.id === payload.articleId) { delete article.removing; }
    return article;
  });

  alertError(t('remove_article_error'));

  return {
    ...state,
    isLoading: false,
    reportedArticles,
  };
};

export const deleteArticlesSuccess = (state, payload) => {
  const deletedIds = payload.deleteArticlesFromDB.articlesIds;
  const deletedCount = deletedIds.length;
  let reportedArticles = state.reportedArticles
    .slice(0)
    .filter(article => deletedIds.indexOf(article.id) === -1);

  if (deletedCount === 1) {
    alertSuccess(t('clean_one_inactive_ready'));
  }
  else {
    alertSuccess(t('clean_all_inactive_ready'));
  }

  return {
    ...state,
    isLoading: false,
    reportedArticles,
    isDeletingArticles: false,
    count: state.count - deletedCount,
  };
};

export const deleteArticlesError = state => {

  alertError(t('remove_article_error'));

  return {
    ...state,
    isLoading: false,
    isDeletingArticles: false,
  };
};

export const fetchReportedArticlesError = state => {
  state.isLoading && alertError(t('server_error'));

  return {
    ...state,
    isLoading: false,
  };
};

export const reportedArticlesOptimistic = (state, payload) => ({
  ...state,
  isAddingArticles: true,
  count: (state.count + (payload.isFamily ? 1 : payload.articlesIds.length)),
});

export const reportedArticlesError = (state, payload) => ({
  ...state,
  isAddingArticles: false,
  count: (state.count -= (payload.isFamily ? 1 : payload.articlesIds.length)),
  countDB: (state.count -= (payload.isFamily ? 1 : payload.articlesIds.length)),
});

export const reportedArticlesUndoOptimistic = state => ({
  ...state,
  count: state.count - 1,
  countDB: state.countDB - 1,
});

export const fetchSendingNoticeStatusSuccess = (state, payload) => {

  const { articles } = payload;



  let { reportedArticles } = state;

  const sendingNotice = state.sendingNotice.slice(0);

  articles.forEach(article => {
    if (
      article.noticed &&
      !article.noticed.sending &&
      sendingNotice.indexOf(article.id) > -1
    ) {
      sendingNotice.splice(sendingNotice.indexOf(article.id), 1);
    }

    reportedArticles = reportedArticles.map(reportedArticle => {
      if (reportedArticle.id === article.id) {
        reportedArticle = {
          ...reportedArticle,
          noticed: {
            ...(reportedArticle.noticed || {}),
            ...(article.noticed || {}),
          }
        };
      }


      return reportedArticle;
    });
  });

  let sentNotices = false;
  if (sendingNotice && sendingNotice.length === 0) {
    const source = state.noticeSource;
    
    if (source === "multiple_denounce_send") {
      // Solicitar denuncia desde múltiple selección
      alertSuccess(t('submit_multiple_denounce_send_ready'));
    } else if (source === "multiple_denounce") {
      // Marcar como sospechosos desde múltiple selección (no debería llegar acá, pero por si acaso)
      if (articles.length === 1) {
        alertSuccess(t('submit_one_reported_ready_multiple_denounce'));
      } else {
        alertSuccess(t('submit_all_reported_ready_multiple_denounce'));
      }
    } else {
      // Flujo normal
      if (articles.length === 1) {
        alertSuccess(t('submit_one_reported_ready'));
      } else {
        alertSuccess(t('submit_all_reported_ready'));
      }
    }
    sentNotices = true;
  }

  return {
    ...state,
    sendingNotice,
    reportedArticles,
    sentNotices,
    noticeSource: null, // Limpiar source después de mostrar el mensaje
  };
};

export const editReportedArticlesOptimistic = (state, payload) => {
  let reportedArticles = state.reportedArticles.slice(0);

  reportedArticles = reportedArticles.map(article => {
    if (payload.articlesIds.indexOf(article.id) > -1) {
      article.editing = true;
    }
    return article;
  });

  return {
    ...state,
    reportedArticles,
  };
};

export const editReportedArticlesSuccess = (state, payload) => {
  let reportedArticles = state.reportedArticles.slice(0);

  reportedArticles = reportedArticles.map(article => {
    if (payload.articlesIds.indexOf(article.id) > -1) {
      article.editing = false;
    }
    return article;
  });

  alertSuccess(t('edit_reported_article_success'));

  return {
    ...state,
    reportedArticles,
  };
};

export const editReportedArticlesError = (state, payload) => {
  let reportedArticles = state.reportedArticles.slice(0);
  reportedArticles = reportedArticles.map(article => {
    if (article.id === payload.articleId) { delete article.editing; }
    return article;
  });

  alertError(t('edit_reported_article_error'));

  return {
    ...state,
    reportedArticles,
  };
};

export const setNotShowMoreError = (state) => {
  alertError(t('server_error'));
  return state;
};


export const errorSendingBrandInfringement = (state, payload) => {
  console.error(payload);
  //alertError(t('brandInfringement.send_error'));
  return state;
};